"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const v4_1 = require("zod/v4");
const WaterfallByExcessMarginBalanceSheetStruct = v4_1.z.object({
    type: v4_1.z.literal('balanceSheet'),
    limitType: v4_1.z.enum(['min', 'max']),
    percentageRate: v4_1.z.number().optional(),
    value: v4_1.z.number().optional(),
});
const WaterfallByExcessMarginCreditFacilityStruct = v4_1.z.object({
    type: v4_1.z.literal('creditFacility'),
    creditFacilityId: v4_1.z.string(),
    limitType: v4_1.z.enum(['min', 'max']),
    percentageRate: v4_1.z.number().optional(),
    value: v4_1.z.number().optional(),
});
const WaterfallByExcessMarginConfigStruct = v4_1.z.discriminatedUnion('type', [
    WaterfallByExcessMarginBalanceSheetStruct,
    WaterfallByExcessMarginCreditFacilityStruct,
]);
//# sourceMappingURL=Assignment.js.map